<!-- spinner -->
<app-spinner *ngIf="loading; else content" [align]="horizontalAlign" [height]="height" [size]="size"></app-spinner>

<!-- content -->
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
